import { Divider } from "@material-ui/core";
import { Box, Button, Fade, Grid, Stack, Tooltip } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import { SendEmailStartReducer } from "../../../_redux/_services/UserManagerSlice";
import { updateLoader } from "../../../_redux/LoaderSlice";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import { decrypt } from "../../../_utilities/_encryptDecryptHelper";
import { setBreadCrumb } from "../../../_utilities/breadCrumb";
import GetJobId from "../../../_utilities/GetJobId";
import {
  formatDate,
  GetTimeZone,
  getWorkonDate,
} from "../../../_utilities/GetTimeZone";
import { getUserDetails, GetUserInfo } from "../../../_utilities/getUserInfo";
import {
  checkRingCentralApp,
  formatPhoneNumber,
  isLoggedIntoRingCentral,
  redirectToLogin,
  triggerRingOut,
} from "../../../_utilities/ringCentralUtils";
import ApplicantCard from "../../../components/ApplicantCard/ApplicantCard";
import CkEditor from "../../../components/CkEditor/CkEditor";
import GenerateTemplate from "../../../components/GenerateTemplate/GenerateTemplate";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import SendSms from "../../../components/SendSms/SendSms";
import {
  applicantCardTitleEnum,
  applicantCardTypeEnum,
  initialApplicantDetails,
} from "../../../constants/constants";
import { ApplicantCallIcon } from "../../../Icons/ApplicantCallIcon";
import { ApplicantCrossIcon } from "../../../Icons/ApplicantCrossIcon";
import { ApplicantEditIcon } from "../../../Icons/ApplicantEditIcon";
import { ApplicantMailIcon } from "../../../Icons/ApplicantMailIcon";
import { ApplicantSmsIcon } from "../../../Icons/ApplicantSmsIcon";
import { ContactApplicantIllu } from "../../../Icons/contactApplicantIllu";
import { Notescall } from "../../../Icons/Notescall";
import { OptionsIcon } from "../../../Icons/optionsIcon";
import { SendSMSillu } from "../../../Icons/SendSMSillu";
import { integrationsMapping } from "../../../ringcentralConfig";
import AddApplicantAssociatedJobs from "../ApplicantsAssociatedJobs/AddApplicantAssociatedJobs";
import AddApplicantDocuments from "../ApplicantsDocuments/AddApplicantDocuments";
import AddApplicantsNotes from "../ApplicantsNotes/AddApplicantsNotes";
import { ApplicantEdit } from "../../../Icons/ApplicantEdit";
import { safeJsonParse } from "../../../_utilities/utilities";
import { safeJSONParse } from "../../../_utilities/constants";
import GenerateTemplateNew from "../../../components/GenerateTemplate/GenerateTemplateNew";
import { ApplicantsDetailsTabsfloatingMenuOptions } from "../../../constants/floatingMenuConstants";
import FloatingMenu from "../../../components/FloatingMenu/FloatingMenu";
import WhatsAppConversation from "../../../components/WhatsAppConversation/WhatsAppConversation";
import {
  getWhatsappIntegration,
  hasAnyPhoneNumber,
} from "../../../_utilities/whatsappContext";
import EmailDeliverySummary from "../../../components/EmailDeliverySummary";

const initalState = { data: null, message: "", isloader: true };

const ApplicantsViewNew = (props) => {
  const [notes, setNotes] = useState([]);
  const [tabvalue, setTabValue] = useState("");
  const [documents, setDocuments] = useState([]);
  const [layoutObj, setLayoutObj] = useState(CallOBJ);
  const [auditlogData, setAuditlogData] = useState([]);
  const [associatedJobs, setAccociatedJobs] = useState([]);
  const [isContactApplicant, setIsContactApplicant] = useState(false);
  const [isFullWidth, setIsFullWidth] = useState(true);
  const [showAddAssociatedJobs, setShowAddAssociatedJobs] = useState(false);
  const [showAddDocuments, setShowAddDocuments] = useState(false);
  const [showAddNotes, setShowAddNotes] = useState(false);
  const [contactMenuOptions, setContactMenuOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const [getDetails, setGetDetails] = useState(initialApplicantDetails);

  let getJobCode = props.getData ? null : GetJobId();

  const column1Ref = useRef(null);
  const column2Ref = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const actionLinks = {
    accociateJobsUrl: `/ats/layout/applicants/associatedjobs/${getJobCode}`,
    documentsUrl: `/ats/layout/applicants/documents/${getJobCode}`,
    notesUrl: `/ats/layout/applicants/notes/${getJobCode}`,
    auditinfoUrl: `/ats/layout/applicants/auditinfo/${getJobCode}`,
  };

  useEffect(() => {
    if (getJobCode !== null) {
      GetData();
    }
  }, [getJobCode]);

  useEffect(() => {
    if (props.getData) {
      dispatch(_ser.applicantsByIdAsync(props.getData.applicantID));
    }
  }, [props.getData]);

  const ApplicantData = useSelector((state) => state.ApplicantsById.data);
  const GetApplicantJobsData = useSelector(
    (state) => state.GetApplicantJobs.data,
  );
  const GetDocumentsdata = useSelector((state) => state.GetDocuments.data);
  const notesData = useSelector((state) => state.ListNotes.data);
  const AuditlogResponse = useSelector(
    (state) => state.GetApplicantsComments.data,
  );
  const sendEmail = useSelector((state) => state.SendEmail.data);

  const customFieldsData = useSelector((state) => state.CustomFields.data);

  const AddAssociatedjobscode = useSelector(
    (state) => state.AddAssociatedjobs.data,
  );

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  useEffect(() => {
    if (AddAssociatedjobscode === 200) {
      dispatch(_ser.addAssociatedjobsStartReducer(initalState));
    }
  }, [AddAssociatedjobscode]);

  const GetData = async () => {
    dispatch(_ser.applicantsByIdAsync(getJobCode));
    dispatch(_ser.getApplicantJobsAsync(getJobCode));
    dispatch(_ser.getDocumentsAsync(getJobCode));
    dispatch(_ser.listNotesAsync(getJobCode));

    let payLoad = { type: "Applicants", typeId: getJobCode };
    dispatch(_ser.getApplicantsCommentsAsync(payLoad));
  };

  useEffect(() => {
    if (ApplicantData && ApplicantData.length > 0) {
      let myData = JSON.parse(JSON.stringify(ApplicantData));
      let educationDetails = [],
        workExperience = [],
        finalCustomFieldsData = [];
      let newObj = {
        Applicants: {
          firstName: myData[0].firstName,
          lastName: myData[0].lastName,
          contactNumber: myData[0].contactNumber,
          alternateContactNumber: myData[0].alternateContactNumber,
          emailId: myData[0].emailId,
          location:
            myData[0]?.formattedLocation ?? "",
        },
        id: myData[0].id,
        applicantName: myData[0].firstName + " " + myData[0].lastName,
        firstName: myData[0].firstName,
        lastName: myData[0].lastName,
        emailId: myData[0].emailId,
        contactNumber: myData[0].contactNumber,
        alternateContactNumber: myData[0].alternateContactNumber,
        source: myData[0].source,
        resumesource: myData[0].resumesource,
        totalExperience:
          myData[0].totalExperience || myData[0].yearsofExperience,
        skillDetails: myData[0].skillDetails
          ? safeJsonParse(myData[0].skillDetails)
          : [],
        certification:
          myData[0].certification && myData[0].certification !== "undefined"
            ? safeJSONParse(JSON.parse(myData[0].certification))
            : [],
        candidateStatus: myData[0].candidateStatus,
        applicantCode: myData[0].applicantCode,
        customFields: myData[0].customFields,
      };

      let educationObj = safeJsonParse(myData[0]?.educationDetails);

      let filterEducationData =
        educationObj?.filter(
          (x) =>
            (x.education || "").trim() !== "" || (x.degree || "").trim() !== "",
        ) || [];
      if (filterEducationData.length > 0) {
        filterEducationData.forEach((item, i) => {
          let newObj = {
            ...item,
            id: i,
            // degree: (item?.degree) ? item?.degree : item?.education,
            title: item?.degree || item?.education,
            organization: item?.organization,
            type: item?.locationFormated || item?.location?.formatted,
            workingOn:
              item?.startDate || item?.endDate
                ? `${item?.startDate ? formatDate(item?.startDate) : ""} ${item?.endDate ? " - " + formatDate(item?.endDate) : ""}`
                : "",
          };
          educationDetails.push(newObj);
        });
      }
      let workExpObj = safeJsonParse(myData[0].workExp);
      let filterWorkData =
        workExpObj?.filter((x) => (x.jobTitle || "").trim() !== "") || [];
      if (filterWorkData.length > 0) {
        filterWorkData.forEach((item, i) => {
          let newObj = { ...item };
          if (newObj.experienceInMonths === undefined) {
            newObj["experienceInMonths"] = getWorkonDate(item, "level1");
          }
          newObj.id = i;
          newObj.title = newObj?.jobTitle;
          newObj.organization = newObj?.organization;
          newObj.type = newObj?.empType;
          newObj.workingOn = getWorkonDate(
            newObj?.experienceInMonths,
            "level2",
          );
          workExperience.push(newObj);
        });
      }
      let customFields = myData[0].customFields
        ? safeJSONParse(JSON.parse(myData[0]?.customFields))
        : [];
      if (customFields !== null && customFields.length > 0) {
        let existingValues = [];
        if (customFieldsData && customFieldsData.length > 0) {
          const data = JSON.parse(JSON.stringify(customFieldsData));
          let customPostingFieldsData = data.filter(
            (x) => x.moduleId.toString() === "2" && x.fieldType === "custom",
          );
          existingValues = customPostingFieldsData.map((x) => {
            return x.fieldName;
          });
          console.log(existingValues);
        }
        customFields.forEach((item, i) => {
          if (
            item.value &&
            item.value?.toString()?.length > 0 &&
            existingValues.includes(item.key)
          ) {
            let newObj = {
              ...item,
              key: item.key,
              value: item.value.toString(),
            };
            finalCustomFieldsData.push(newObj);
          }
        });
      }
      let designation =
        workExperience?.length > 0
          ? `${workExperience[0]?.title || ""}${workExperience[0]?.organization ? " / " + workExperience[0]?.organization : ""}`
          : "";
      newObj["customFieldsArray"] = finalCustomFieldsData;
      newObj.educationDetails = educationDetails;
      newObj.workExp = workExperience;
      newObj.currentWorking = {
        designation: designation,
        from: workExperience[0]?.workingOn,
      };
      setGetDetails(newObj);
      if (myData[0].firstName) {
        let additionalData = {
          applicantName:
            newObj.Applicants.firstName + " " + newObj.Applicants.lastName,
          currentWorking: newObj.currentWorking,
          emailId: newObj.Applicants.emailId,
          contactNumber: newObj.Applicants.contactNumber,
          alternateContactNumber: newObj.Applicants.alternateContactNumber,
          linkedIn: myData[0]?.linkedIn ?? "",
          location:
            newObj.Applicants.location ||
            myData[0]?.formattedLocation?.trim() ||
            [myData[0]?.locationCity, myData[0]?.locationState, myData[0]?.locationCountry]
              .filter(Boolean).join(", "),
        };
        setBreadCrumb(
          myData[0].id,
          myData[0]?.fullName ? myData[0]?.fullName : newObj.applicantName,
          "Applicant Code",
          additionalData,
        );
      }
      localStorage.removeItem("OverwriteEditObj")
      dispatch(_ser.applicantsByIdStartReducer(initalState));
    }
  }, [ApplicantData, customFieldsData]);

  useEffect(() => {
    if (GetDocumentsdata !== null) {
      let docData = JSON.parse(JSON.stringify(GetDocumentsdata));
      let documentsData = [];
      if (docData.length > 0) {
        docData.forEach((list, i) => {
          let obj = {
            id: list.id || i, // Use unique ID if available
            key: [
              "Document Name",
              "Uploaded by",
              "Document Type",
              "Sourced from",
            ],
            value: [
              list?.name?.replaceAll("-", " "),
              `${list.firstName || ""} ${list.lastName || ""}`.trim(),
              list.documentType,
              list.resumesource,
            ],
            fileType: list.fileType,
            ...list,
          };
          documentsData.push(obj);
        });
        setDocuments(documentsData.reverse());
        dispatch(_ser.getDocumentsStartReducer(initalState));
      } else {
        setDocuments([]);
      }
    }
  }, [GetDocumentsdata]);

  useEffect(() => {
    if (GetApplicantJobsData && GetApplicantJobsData?.length > 0) {
      let myData = JSON.parse(JSON.stringify(GetApplicantJobsData));
      let newArray = [];
      myData.forEach((e, i) => {
        let obj = {
          id: i,
          key: [
            "Job Code",
            "Job Title",
            "Candidate Status",
            ...(e.clientName ? ["Client"] : []),
          ],
          value: [
            e.jobCode,
            e.jobTitle,
            e.status,
            ...(e.clientName ? [e.clientName] : []),
          ],
          ...e,
        };
        newArray.push(obj);
      });
      setAccociatedJobs(newArray);
      dispatch(_ser.getApplicantJobsStartReducer(initalState));
    }
  }, [GetApplicantJobsData]);

  useEffect(() => {
    if (notesData !== null) {
      let data = JSON.parse(JSON.stringify(notesData));
      setNotes(data);
      dispatch(_ser.listNotesStartReducer(initalState));
    }
  }, [notesData]);

  useEffect(() => {
    if (AuditlogResponse && AuditlogResponse.length > 0) {
      const auditlogData = AuditlogResponse.map((item, i) => ({
        id: item.id || i,
        key: ["Name", "Action Performed", "Date and Time"],
        value: [
          item?.fullName || "",
          item?.action || "",
          GetTimeZone(item?.createdAt),
        ],
      }));
      setAuditlogData(auditlogData);
      dispatch(_ser.getApplicantsCommentsStartReducer(initalState));
    }
  }, [AuditlogResponse]);

  useEffect(() => {
    if (sendEmail === 200) {
      dispatch(_ser.listNotesAsync(getJobCode)); // Refresh notes list
      dispatch(SendEmailStartReducer(initalState));
    }
  }, [sendEmail]);

  const onReceivePropsHandler = (pannel, load) => {
    if (load === "close" || load === "sms") {
      setIsContactApplicant(pannel);
      setTabValue("");
      // if (load === "sms") {
      //     dispatch(_ser.listNotesAsync(getJobCode));
      // }
    } else if (load) {
      setTabValue(load);
    } else if (load === "isImageFalse") {
      setLayoutObj(CallConnectedOBJ);
    }
  };

  useEffect(() => {
    const updateHeights = () => {
      if (column1Ref.current && column2Ref.current) {
        const height1 = column1Ref.current.offsetHeight;
        const height2 = column2Ref.current.offsetHeight;
        if (height1 + 20 < height2) {
          setIsFullWidth(false);
        } else {
          setIsFullWidth(true);
        }
        console.log("height1:", height1, "height2:", height2);
      }
    };
    if (getDetails) {
      updateHeights();
      window.addEventListener("resize", updateHeights);
      return () => window.removeEventListener("resize", updateHeights);
    }
  }, [getDetails]);

  const renderingUI = (object, cardType, title) => {
    let isAction = false,
      actionLink = null,
      nodata = "",
      type = "",
      isAddSection = false;
    switch (cardType) {
      case applicantCardTitleEnum.WORK_EXP:
        type = applicantCardTypeEnum.LIST_WITH_JUSTIFY;
        break;
      case applicantCardTitleEnum.EDUCATION_DETAILS:
        type = applicantCardTypeEnum.LIST_WITH_JUSTIFY;
        break;
      case applicantCardTitleEnum.CUSTOM_FIELDS_ARRAY:
        type = applicantCardTypeEnum.LIST_WITH_COLUMN;
        break;
      case applicantCardTitleEnum.CERTIFICATION:
      case applicantCardTitleEnum.SKILL_DETAILS:
        type = applicantCardTypeEnum.LIST;
        break;
      case applicantCardTitleEnum.ASSOCIATED_JOBS:
        isAction = Boolean(associatedJobs.length > 0);
        actionLink = actionLinks.accociateJobsUrl;
        nodata = "No associated jobs found";
        isAddSection = true;
        type = applicantCardTypeEnum.LIST_WITH_COLUMN;
        break;
      case applicantCardTitleEnum.DOCUMENTS:
        isAction = Boolean(documents.length > 0);
        actionLink = actionLinks.documentsUrl;
        isAddSection = true;
        nodata = "No documents found";
        type = applicantCardTypeEnum.LIST_WITH_COLUMN;
        break;
      case applicantCardTitleEnum.NOTES:
        isAction = Boolean(notes.length > 0);
        actionLink = actionLinks.notesUrl;
        nodata = "No notes found";
        isAddSection = true;
        type = applicantCardTypeEnum.CUSTOM_LAYOUT;
        break;
      case applicantCardTitleEnum.AUDITLOG_DATA:
        isAction = Boolean(auditlogData.length > 0);
        actionLink = actionLinks.auditinfoUrl;
        nodata = "No audit Info found";
        type = applicantCardTypeEnum.LIST_WITH_COLUMN;
        break;
    }

    const onReceivePropsHandler = (type) => {
      setShowAddAssociatedJobs(false);
      setShowAddDocuments(false);
      setShowAddNotes(false);
      if (typeof type === "boolean") {
        GetData();
      } else {
        if (type.includes("associated")) {
          setShowAddAssociatedJobs(true);
        } else if (type.includes("documents")) {
          setShowAddDocuments(true);
        } else if (type.includes("notes")) {
          setShowAddNotes(true);
        }
      }
    };

    return (
      <ApplicantCard
        data={object}
        title={title}
        isAction={isAction}
        actionLink={actionLink}
        nodata={nodata}
        type={type}
        isAddSection={isAddSection}
        onReceiveProps={onReceivePropsHandler}
      />
    );
  };

  const onPropsReceiveHandler = (value, type) => {
    if (type === "getFetch" || type === true || value === true) {
      if (showAddAssociatedJobs) {
        dispatch(_ser.getApplicantJobsAsync(getJobCode));
        dispatch(_ser.getApplicantsCommentsAsync({ type: "Applicants", typeId: getJobCode }));
      } else if (showAddDocuments) {
        dispatch(_ser.getDocumentsAsync(getJobCode));
        dispatch(_ser.getApplicantsCommentsAsync({ type: "Applicants", typeId: getJobCode }));
      } else if (showAddNotes) {
        dispatch(_ser.listNotesAsync(getJobCode));
        dispatch(_ser.getApplicantsCommentsAsync({ type: "Applicants", typeId: getJobCode }));
      } else {
        GetData();
      }
    }
    if (type === "close" || type === "Back" || (value === false && type !== "getFetch")) {
      setShowAddAssociatedJobs(false);
      setShowAddDocuments(false);
      setShowAddNotes(false);
    }
  };

  useEffect(() => {
    async function init() {
      const userDetails = await GetUserInfo();
      const selectCountry = JSON.parse(decrypt("selectCountry"));
      const integrations = userDetails?.[0]?.integrations
        ? JSON.parse(userDetails[0].integrations)
        : [];
      // const availableMenus = [
      //   {
      //     id: 0,
      //     label: "Edit Profile",
      //     icon: <ApplicantEdit />, // <ApplicantEditIcon />,
      //     onClick: () => navigate(`/ats/layout/applicants/edit/${getJobCode}`),
      //   },
      //   {
      //     id: 1,
      //     label: "Email Candidate",
      //     icon: <ApplicantMailIcon />,
      //     onClick: () => {
      //       onNavigateHandler("Send E-mail");
      //     },
      //   },
      // ];
      const availableMenus = [
        ...ApplicantsDetailsTabsfloatingMenuOptions.inline,
      ];
      // Add Call and Send SMS option dynamically based on integrations
      integrations.forEach((integration) => {
        const integrationConfig = integrationsMapping[integration.attribute_5];
        // Check if attribute_4 contains the selected country or is empty (case insensitive)
        const countriesArray = integration.attribute_4
          ? integration.attribute_4
              .split(",")
              .map((country) => country.trim().toLowerCase())
          : [];
        const selectedCountryLower = selectCountry.name.toLowerCase();
        const shouldAddMenu =
          countriesArray.length === 0 ||
          countriesArray.includes(selectedCountryLower);
        if (
          integrationConfig &&
          integration[integrationConfig.active] === "Yes" &&
          shouldAddMenu
        ) {
          if (integration[integrationConfig.features]?.includes("Calls")) {
            availableMenus.unshift({
              // id: 2,
              label: "Make a Call",
              action: "Call",
              icon: "ApplicantCallIcon", // <ApplicantCallIcon />
              // onClick: () => onNavigateHandler("Call"),
            });
          }
          if (integration[integrationConfig.features]?.includes("Messages")) {
            availableMenus.unshift({
              // id: 3,
              label: "Send an SMS",
              action: "Send SMS",
              icon: "SendSMS", // <ApplicantSmsIcon />
              // onClick: () => onNavigateHandler("Send SMS"),
            });
          }
        }
        // WhatsApp: surface icon when the customer has an active Whatsapp
        // integration. Phone-number gating happens at render time so we can
        // re-evaluate once applicant data has loaded.
        if (
          integration.attribute_5 === "Whatsapp" &&
          integration.active === "Yes"
        ) {
          availableMenus.unshift({
            label: "WhatsApp",
            action: "WhatsApp",
            icon: "ApplicantWhatsAppIcon",
          });
        }
      });
      setContactMenuOptions(availableMenus);
      console.log(availableMenus);
    }
    init();
  }, []);

  /** Inline, file-local actions bar (no separate file needed) — JS version */
  function ApplicantInlineActions({ actions, hideClose = false, size = 36 }) {
    const [open, setOpen] = useState(false);

    const ActionItem = ({ icon, label, onClick }) => (
      <Box display="flex" flexDirection="column" alignItems="center" gap={0.5}>
        <Tooltip title={label} arrow>
          <span onClick={onClick} aria-label={label}>
            {icon}
          </span>
        </Tooltip>
        {/* <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {label}
      </Typography> */}
      </Box>
    );

    if (!open) {
      return (
        <Tooltip title="View More Options" arrow>
          <span style={{ cursor: "pointer" }} onClick={() => setOpen(true)}>
            <OptionsIcon />
          </span>
        </Tooltip>
      );
    }

    return (
      <Fade in={open}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          wrap="nowrap"
          sx={{ mx: 0, width: "auto" }}
        >
          {actions.map((a, idx) => (
            <Grid item key={idx}>
              <ActionItem icon={a.icon} label={a.label} onClick={a.onClick} />
            </Grid>
          ))}
          {!hideClose && (
            <Grid item>
              <ActionItem
                icon={<ApplicantCrossIcon />}
                label="Close"
                onClick={() => setOpen(false)}
              />
            </Grid>
          )}
        </Grid>
      </Fade>
    );
  }

  const onNavigateHandler = (type) => {
    if (
      type === "Call" ||
      type === "Send SMS" ||
      type === "Send E-mail" ||
      type === "WhatsApp"
    ) {
      setIsContactApplicant(true);
      setTabValue(type);
      setSelectedOption(type);
    } else if (type === "edit") {
      navigate(`/ats/layout/applicants/edit/${getJobCode}`);
    }
  };

  return (
    <>
      <div className="applicant-view-header applicantFloatingMenu">
        {/* <ApplicantInlineActions actions={contactMenuOptions} /> */}
        <FloatingMenu
          config={{
            inlineOptions: contactMenuOptions.filter((opt) =>
              opt.action === "WhatsApp"
                ? hasAnyPhoneNumber(getDetails?.Applicants?.contactNumber)
                : true,
            ),
          }}
          floatingMenuOptions={ApplicantsDetailsTabsfloatingMenuOptions}
          onReceiveActionHandler={onNavigateHandler}
          storedTheme={storedTheme}
        />
      </div>
      <Grid container spacing={3}>
        {getDetails && (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={8}
            style={{ margin: "0 auto" }}
          >
            <div ref={column1Ref}>
              {getDetails.workExp && getDetails.workExp.length > 0 && (
                <>
                  {renderingUI(
                    getDetails?.workExp,
                    applicantCardTitleEnum.WORK_EXP,
                    `${getDetails?.totalExperience ? `Work Experience (${getDetails?.totalExperience} years)` : "Work Experience"}`,
                  )}
                </>
              )}
              {getDetails.certification &&
                getDetails.certification.length > 0 && (
                  <>
                    {renderingUI(
                      getDetails?.certification,
                      applicantCardTitleEnum.CERTIFICATION,
                      "Certifications",
                    )}
                  </>
                )}
              {getDetails.educationDetails &&
                getDetails.educationDetails.length > 0 && (
                  <>
                    {renderingUI(
                      getDetails?.educationDetails,
                      applicantCardTitleEnum.EDUCATION_DETAILS,
                      "Education Details",
                    )}
                  </>
                )}
              {getDetails.customFieldsArray &&
                getDetails.customFieldsArray.length > 0 && (
                  <>
                    {renderingUI(
                      getDetails?.customFieldsArray,
                      applicantCardTitleEnum.CUSTOM_FIELDS_ARRAY,
                      "Additional Information",
                    )}
                  </>
                )}
            </div>
            {isFullWidth === false &&
              getDetails?.skillDetails &&
              getDetails?.skillDetails.length > 0 && (
                <div className="update_column_view">
                  {renderingUI(
                    getDetails?.skillDetails,
                    applicantCardTitleEnum.SKILL_DETAILS,
                    "Skills",
                  )}
                </div>
              )}
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={12} lg={4} style={{ margin: "0 auto" }}>
          <div ref={column2Ref}>
            {associatedJobs && (
              <>
                {renderingUI(
                  associatedJobs?.slice(0, 1),
                  applicantCardTitleEnum.ASSOCIATED_JOBS,
                  `Associated Jobs (${associatedJobs.length})`,
                )}
              </>
            )}
            {documents && (
              <>
                {renderingUI(
                  documents?.slice(0, 1),
                  applicantCardTitleEnum.DOCUMENTS,
                  `Documents (${documents.length})`,
                )}
              </>
            )}
            {notes && (
              <>
                {renderingUI(
                  notes?.slice(0, 1),
                  applicantCardTitleEnum.NOTES,
                  `Notes (${notes.length})`,
                )}
              </>
            )}
            {auditlogData && (
              <>
                {renderingUI(
                  auditlogData?.slice(0, 1),
                  applicantCardTitleEnum.AUDITLOG_DATA,
                  `Audit Info (${auditlogData.length})`,
                )}
              </>
            )}
          </div>
        </Grid>
        {isFullWidth === true && (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ margin: "0 auto", marginTop: "-20px" }}
          >
            {getDetails?.skillDetails &&
              getDetails?.skillDetails.length > 0 && (
                <>
                  {renderingUI(
                    getDetails?.skillDetails,
                    applicantCardTitleEnum.SKILL_DETAILS,
                    "Skills",
                  )}
                </>
              )}
          </Grid>
        )}
      </Grid>

      {Boolean(isContactApplicant) && (
        <div
          id={
            tabvalue === "Call" || tabvalue === "isImageFalse"
              ? "callSection"
              : ""
          }
        >
          <RightSideBar
            componentData={
              <ComponentRenderData
                isAssociatedProfile={false}
                applicantDetails={getDetails}
                jobCode={null}
                onReceiveProps={onReceivePropsHandler}
                selectedOption={selectedOption}
              />
            }
            componentLayout={
              tabvalue === "Send E-mail"
                ? MailOBJ
                : tabvalue === "Send SMS"
                  ? smsOBJ
                  : tabvalue === "Call"
                    ? CallOBJ
                    : tabvalue === "WhatsApp"
                      ? WhatsAppOBJ
                      : tabvalue === "isImageFalse"
                        ? CallConnectedOBJ
                        : ""
            }
            footerImg={
              tabvalue === "Send E-mail" ? (
                <SendSMSillu />
              ) : tabvalue === "Send SMS" ? (
                <SendSMSillu />
              ) : tabvalue === "Call" ? (
                <ContactApplicantIllu />
              ) : tabvalue === "WhatsApp" ? (
                ""
              ) : tabvalue === "isImageFalse" ? (
                ""
              ) : (
                <ContactApplicantIllu />
              )
            }
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      )}
      {showAddAssociatedJobs && (
        <AddApplicantAssociatedJobs
          componentType="AssociatedJobs"
          isRightSidePannel={false}
          AccociatedJobSeekerList={associatedJobs}
          onPropsReceive={onPropsReceiveHandler}
          questionsData={[]}
          getData={null}
          pannelobj={null}
        />
      )}
      {showAddDocuments && (
        <AddApplicantDocuments
          HandlerType="New document"
          JobId={getJobCode}
          previewType={""}
          DocName={""}
          onReceivePropsHandler={onPropsReceiveHandler}
        />
      )}
      {showAddNotes && (
        <AddApplicantsNotes
          onReceivePropsHandler={onPropsReceiveHandler}
          noteState="Create"
          selectedNote={null}
        />
      )}
      <EmailDeliverySummary candidateMailId={getDetails?.Applicants?.emailId} />
    </>
  );
};

export default ApplicantsViewNew;

const ComponentRenderData = ({
  isAssociatedProfile,
  applicantDetails,
  jobCode,
  onReceiveProps,
  selectedOption,
}) => {
  const [callNotes, setCallNotes] = useState(``);
  const [callState, setCallState] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");
  const [connectedTime, setConnectedTime] = useState("");
  const [dropdownoptions, setDropdownoptions] = useState([]);

  const jobId = GetJobId();
  const isLoggedIn = isLoggedIntoRingCentral();

  const dispatch = useDispatch();

  // useEffect(() => {
  //     const userDetails = GetUserInfo();
  //     const selectCountry = JSON.parse(decrypt('selectCountry'));
  //     const integrations = userDetails?.[0]?.integrations ? JSON.parse(userDetails[0].integrations) : [];
  //     const availableMenus = [
  //         { id: 0, name: 'Send E-mail', navigate: true, url: `` },
  //     ];
  //     // Add Call and Send SMS option dynamically based on integrations
  //     integrations.forEach((integration) => {
  //         const integrationConfig = integrationsMapping[integration.attribute_5];
  //         // Check if attribute_4 contains the selected country or is empty (case insensitive)
  //         const countriesArray = integration.attribute_4
  //             ? integration.attribute_4.split(',').map(country => country.trim().toLowerCase())
  //             : [];
  //         const selectedCountryLower = selectCountry.name.toLowerCase();
  //         const shouldAddMenu = countriesArray.length === 0 || countriesArray.includes(selectedCountryLower);
  //         if (integrationConfig &&
  //             integration[integrationConfig.active] === "Yes" &&
  //             shouldAddMenu) {
  //             if (integration[integrationConfig.features].includes("Calls")) {
  //                 availableMenus.push({ id: 1, name: 'Call', navigate: false, isTemplate: true });
  //             } if (integration[integrationConfig.features].includes("Messages")) {
  //                 availableMenus.push({ id: 2, name: 'Send SMS', navigate: false, isTemplate: true });
  //             }
  //         }
  //     });
  //     setDropdownoptions(availableMenus);
  //     console.log(availableMenus);
  // }, []);

  // const handleSelectChange = (event) => {
  //     setSelectedOption(event.target.value);
  //     onReceivePropsHandler(false, event.target.value);
  // };

  useEffect(() => {
    if (selectedOption !== "") {
      onReceivePropsHandler(false, selectedOption);
    }
    console.log("selectedOption changed:", selectedOption);
  }, [selectedOption]);

  const ckeditor = (data) => {
    setCallNotes(data);
  };

  useEffect(() => {
    let date = new Date();
    setCallNotes(
      `Call Initiated with  ${applicantDetails.firstName} ${GetTimeZone(date)}`,
    );
  }, []);

  const handleCallInitiate = async () => {
    dispatch(updateLoader(true));

    try {
      setErrorMessage(""); // Clear any existing errors
      const formattedNumber = formatPhoneNumber(applicantDetails.contactNumber);
      // Check if the RingCentral app is installed
      const appExists = await checkRingCentralApp(formattedNumber);
      console.log("App exists:", appExists);
      if (appExists) {
        dispatch(updateLoader(false));
        // If the app exists, show the message after the user interacts with the app
        setCallState("connected");
        setErrorMessage(
          "We found the RingCentral app. Initiating the call through the app.",
        );
        return;
      }
      // If the app is not found, check if the user is logged in
      if (!isLoggedIn) {
        dispatch(updateLoader(false));
        setErrorMessage("Please login to RingCentral to make a call.");
        return;
      }
      // Proceed with RingOut if logged in but the app is not found
      setCallState("calling");
      setErrorMessage(
        "We don't see the RingCentral app installed. Making the call through RingOut...",
      );
      // Fetch the stored main number and extension
      const companyMainNumber = localStorage.getItem("ringCentralMainNumber");
      const userExtension = localStorage.getItem("ringCentralUserExtension");

      if (!companyMainNumber || !userExtension) {
        dispatch(updateLoader(false));
        setErrorMessage(
          "Unable to retrieve RingCentral user details. Please try logging in again.",
        );
        return;
      }

      const fromNumber = `${companyMainNumber}*${userExtension}`;
      const ringOutResponse = await triggerRingOut(formattedNumber, fromNumber); // Replace with your verified number
      console.log("RingOut response:", ringOutResponse);

      dispatch(updateLoader(false));
      if (
        ringOutResponse &&
        ringOutResponse.status.callStatus === "InProgress"
      ) {
        setCallState("connected");
        setErrorMessage("We have successfully made the call via RingOut.");
        onReceiveProps(false, "isImageFalse");
      } else {
        throw new Error("Failed to initiate the call through RingOut.");
      }
    } catch (error) {
      console.error("Call initiation failed:", error);
      setCallState("idle");
      setErrorMessage(
        "An error occurred while trying to make the call. Please try again.",
      );
    }
    let date = new Date();
    setConnectedTime(date);
  };

  const handleLogin = () => {
    redirectToLogin();
  };

  const handleSaveNotes = async (event) => {
    event.preventDefault();
    try {
      const userInfo = await getUserDetails();
      const notePayload = {
        notes: callNotes,
        noteType: "Call",
        moduleType: "applicants",
        moduleId: jobId,
        userId: userInfo.userId,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
      };
      await dispatch(_ser.addNotesAsync(notePayload)); // Dispatch add notes action
      dispatch(
        updateSnackbar({
          type: "success",
          message: "Call notes saved successfully!",
        }),
      );
      setCallNotes(""); // Clear notes input
      setCallState("idle"); // Reset state
      onReceiveProps(false, "close");
      await dispatch(_ser.listNotesAsync(jobId)); // Refresh notes list
      setErrorMessage("");
    } catch (error) {
      console.error("Error saving call notes:", error);
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Failed to save call notes. Please try again.",
        }),
      );
    }
  };

  const handleCancelCall = () => {
    setCallState("idle");
    setErrorMessage("");
  };

  const onReceivePropsHandler = (pannel, load) => {
    onReceiveProps(false, load);
  };

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  return (
    <>
      {/* {selectedOption === '' && (
                <div>
                    <FormControl fullWidth autoComplete="off" style={{ marginBottom: "34px" }}>
                        <InputLabel className="boldSelectlabel">Select to Contact</InputLabel>
                        <Select
                            value={selectedOption}
                            onChange={handleSelectChange}
                            name="template"
                            autoComplete="off"
                            label=" Select to Contact *&nbsp;&nbsp;&nbsp;"
                            style={{ width: "65%", height: "3.5rem", borderRadius: "4px", textAlign: "left" }}
                        >
                            {dropdownoptions.map((menu) => (
                                <MenuItem className="selectOptions" key={menu.id} value={menu.name}>
                                    {menu.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            )} */}
      {selectedOption === "Send E-mail" && (
        <GenerateTemplateNew
          isAssociatedProfile={false}
          applicantDetails={applicantDetails}
          jobCode={null}
          onReceiveProps={onReceivePropsHandler}
          to={"applicants"}
        />
      )}

      {selectedOption === "Send SMS" && (
        <SendSms
          data={applicantDetails}
          onReceivechildProps={onReceivePropsHandler}
        />
      )}

      {selectedOption === "WhatsApp" && (
        <WhatsAppConversation
          applicantDetails={applicantDetails?.Applicants || applicantDetails}
          integration={getWhatsappIntegration()}
        />
      )}

      {selectedOption === "Call" && (
        <>
          <div>
            <h3
              style={{
                textAlign: "left",
                marginTop: "4px",
                marginBottom: "8px",
                fontSize: "22px",
                fontFamily: "Roboto",
              }}
            >
              Call
            </h3>
            <Divider className="secline" />
            <table style={{ marginTop: "15px", color: "#3E3E3E" }}>
              <tbody>
                <tr>
                  <td style={{ padding: "10px 0px" }}>Applicant Name</td>
                  <td style={{ padding: "10px" }}>:</td>
                  <td style={{ textAlign: "left", padding: "10px 6px" }}>
                    {applicantDetails.firstName} {applicantDetails.lastName}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "10px 0px", textAlign: "left" }}>
                    Contact Number
                  </td>
                  <td>:</td>
                  <td style={{ padding: "10px 6px" }}>
                    {applicantDetails.contactNumber}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Error or Login Prompt */}
          {errorMessage && (
            <div style={{ marginTop: "30px" }}>
              <p
                style={{
                  color: callState === "connected" ? "green" : "red",
                  margin: "3px",
                }}
                className="text-left "
              >
                {errorMessage}
              </p>
              {!isLoggedIn && callState === "idle" && (
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "var(--primary-bg-color)",
                    borderRadius: "10px",
                    color: "var(--primary-background-text-color)",
                    marginTop: "20px",
                  }}
                  onClick={handleLogin}
                >
                  Login to RingCentral
                </Button>
              )}
            </div>
          )}

          {/* Call Button */}
          {!errorMessage && callState === "idle" && (
            <div className="call-button" onClick={handleCallInitiate}>
              <Notescall
                primaryColor={storedTheme?.primaryColor}
                secondaryColor={storedTheme?.secondaryColor}
              />
              <p>Call Applicant</p>
            </div>
          )}

          {/* Calling State */}
          {callState === "calling" && (
            <div className="content-center">
              <div className="pulse">
                <img
                  src={process.env.PUBLIC_URL + "/assests/img/Notescall.svg"}
                  alt="Calling Icon"
                  className="calling-icon"
                />
              </div>
              <p className="callingtext">Calling Applicant...</p>
            </div>
          )}

          {/* Connected State */}
          {callState === "connected" && (
            <div className="connected-div">
              <div className="call-connected">
                <img
                  src={process.env.PUBLIC_URL + "/assests/img/phone.svg"}
                  alt=""
                  style={{ height: "23px", width: "23px" }}
                  className="phone-icon"
                />
                <p className="sucesses-text">
                  Successfully Connected With Applicant
                </p>
              </div>
              <p className="text-left" style={{ margin: "3px" }}>
                Add Notes here
              </p>
              <CkEditor
                data={callNotes}
                name="callNotes"
                autoComplete="off"
                onUpdatehandler={(update) => {
                  ckeditor(update.data);
                }}
              />
              <div className="cancelsave-btns" style={{ marginTop: "20px" }}>
                <Stack spacing={2} direction="row">
                  <Button
                    variant="text"
                    sx={{ color: "#FF0000" }}
                    onClick={handleCancelCall}
                    size="small"
                  >
                    <Link
                      href="#"
                      className="cancel-btn"
                      style={{ color: "red" }}
                      underline="always"
                    >
                      Cancel
                    </Link>
                  </Button>
                  <Button
                    className="savebtn"
                    variant="contained"
                    onClick={handleSaveNotes}
                    size="small"
                    style={{
                      backgroundColor: "var(--primary-bg-color)",
                      borderRadius: "10px",
                      color: "var(--primary-background-text-color)",
                    }}
                  >
                    Save
                  </Button>
                </Stack>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

const MailOBJ = {
  title: "Send E-mail",
  description: "",
  bgImage: `${process.env.PUBLIC_URL}/assests/img/emailbackground.svg`,
};

const CallOBJ = {
  title: "Call Candidate",
  description: "",
  bgImage: `${process.env.PUBLIC_URL}/assests/img/CallBackground.png`,
};

const CallConnectedOBJ = {
  title: "Call Candidate",
  description: "",
  bgImage: ``,
};
const ContactCandidate = {
  title: "Contact candidate",
  description: "Choose one option to contact candidate",
  bgImage: ``,
};
const smsOBJ = {
  title: "Send SMS",
  description: "",
  bgImage: `${process.env.PUBLIC_URL}/assests/img/emailbackground.svg`,
};
const WhatsAppOBJ = {
  title: "WhatsApp Conversation",
  titleColor: "#FFC107",
  description: "",
  bgImage: ``,
};
